<template>
  <div class="login_container">
    <div class="login_box">

      <div class="avatar_box">
        <h2 style="color: #0f0f0f;">数据测试</h2>
      </div>

      <el-form class="login_form" ref="login_form" :model="loginForm" label-width="0px" :rules="rules">   

        <el-form-item prop="username">   
          <el-input v-model="loginForm.username" size="medium">
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.password" size="medium" show-password>
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </el-form-item>

        <el-form-item  class="btns">
          <!--  @click="submitForm('login_form')" -->
          <el-button size="medium"  @click.native.prevent="handleLogin">登录</el-button>
          <el-button size="medium" @click="resetForm('login_form')">重置</el-button>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { validUsername } from '@/utils/validate'
  export default {
    data(){
      const validateUsername = (rule, value, callback) => {
        if (!validUsername(value)) {
          callback(new Error('Please enter the correct user name'))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (value.length < 6) {
          callback(new Error('The password can not be less than 6 digits'))
        } else {
          callback()
        }
      }
      return{

        imgUrl:'',
        loading: '',
        redirect: undefined,

        loginForm:{
          username:'admin',
          password:'12345',
        },

        rules: {//表单的验证规则对象
          username: [//验证用户名是否合法
            { required: true, message: '请输入登录名称', trigger: 'blur'}],
          password:[//验证密码
            { required: true, message: '请输入登录密码', trigger: 'blur' }],
      }
    };
  },

  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },


  methods: {
    submitForm(formName) {//登录
      // this.$refs[formName].validate(valid => {
      // if (valid) {
      // this.$router.push('/home')
      // }
      // });
    },

   handleLogin() {
        this.$refs.login_form.validate(valid => {
          if (valid) 
          {
            this.loading = true
            // vuex
            this.$store.dispatch('user/login', this.loginForm).then(() => {
              
              this.$router.push({ path:'/PLCdata' })
              this.loading = false
            }).catch
            (() => {             
              this.loading = false
            })
          }
          else
          {
            console.log('error submit!!')
            return false
          }
        })
      }
      ,
      resetForm(formName) {//重置
      console.log(formName);
        this.$refs[formName].resetFields();
        console.log(this.loginForm);
        }
    },
  }
</script>

<style lang="less" scoped>
.login_container{
  background: url(../assets/bg2.jpg) no-repeat center center;
  background-size: cover;
  height: 100%;
  width: 100%;
}
.login_box{
  width: 450px;
  height: 300px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.avatar_box {
  width: 100%;
  text-align: center;
}
.login_form{
  position: absolute;
  bottom: 20px;
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  .el-form-item {
    margin-bottom: 15px;
  }
  /deep/ .el-input .el-input__inner {
    background-color: rgba(0, 0, 0, 0);
    color: #151515;
    border: 1px solid #0f0f0f;
    font-size: 16px;
    padding: 0 15px 0 35px;
  }
  /deep/ .el-input .el-input__inner:focus {
    border: 1px solid #0f0f0f;
  }
  i {
    color: #0f0f0f;
    font-size: 20px;
    vertical-align:middle
  }
}
.btns{
  display: flex;
  justify-content: center;
  .el-button {
    color: #0f0f0f;
    border-color: #0f0f0f;
    background-color: rgba(0, 0, 0, 0);
  }
  .el-button:focus, .el-button:hover {
    color: #0f0f0f;
    border-color: #0f0f0f;
    background-color: rgba(0, 0, 0, 0);
  }
}
.code{
  width: 275px;
  margin-right: 15px;
}
.codeimg{
  width: 80px;
  height: 40px;
  float: right;
  img{
    height: 100%;
    width: 100%;
  }
}
.codeimg :hover{
  cursor:pointer
}
</style>
